<template>
  <section class="section">
    <div class="container">
      <div class="columns">
        <div class="column is-10">
          <h1 class="title">
            <template v-if="id == undefined">
              {{ $translate('new_client') }}
            </template>
            <template v-else>
              {{ $translate('modify_client') }}
            </template>
          </h1>
        </div>
        <div class="column has-text-right">
          <b-field grouped position="is-right">
            <b-field>
              <b-tooltip
                v-if="id != undefined"
                :label="$translate('delete') | capitalize"
                position="is-left"
                type="is-danger"
              >
                <button class="button is-danger" @click="deleteItem()">
                  <b-icon icon="delete-outline"></b-icon>
                </button>
              </b-tooltip>
            </b-field>
            <b-field>
              <b-tooltip :label="$translate('save') | capitalize" position="is-left">
                <button class="button is-primary" @click="send(false)">
                  <b-icon icon="content-save-outline"></b-icon>
                </button>
              </b-tooltip>
            </b-field>
            <b-field>
              <b-tooltip :label="$translate('save_exit') | capitalize" position="is-left">
                <button class="button is-primary" @click="send(true)">
                  <b-icon icon="exit-to-app"></b-icon>
                </button>
              </b-tooltip>
            </b-field>
          </b-field>
        </div>
      </div>
      <b-field
        :type="{ 'is-danger': errors.has('mercurio_id') }"
        :message="errors.first('mercurio_id')"
        horizontal
        :label="$translate('id_mercury') | capitalize"
      >
        <b-input v-model="company.mercurio_id" v-validate="'required'" name="mercurio_id"></b-input>
      </b-field>
      <b-field
        :type="{ 'is-danger': errors.has('name') }"
        :message="errors.first('name')"
        horizontal
        :label="$translate('name') | capitalize"
      >
        <b-input v-model="company.name" v-validate="'required'" name="name"></b-input>
      </b-field>
      <!--<b-field :label="$translate('country') | capitalize" horizontal>
        <b-select :placeholder="$translate('placeholder_country')" v-model="company.country">
          <option
            v-for="option in countries"
            :value="option['code']"
            :key="option['code']"
            >{{ $translate(option["code"]) }}</option
          >
        </b-select>
      </b-field>-->
      <b-field
        horizontal
        :label="$translate('mail') | capitalize"
        :type="{ 'is-danger': errors.has('email') }"
        :message="errors.first('email')"
      >
        <b-input v-model="company.email" v-validate="'email|required'" name="email"></b-input>
      </b-field>
      <b-field
        horizontal
        :label="$translate('tel') | capitalize"
        :type="{ 'is-danger': errors.has('phone') }"
        :message="errors.first('phone')"
      >
        <b-input v-model="company.phone" v-validate="'required'" name="phone"></b-input>
      </b-field>
      <b-field
        :type="{ 'is-danger': errors.has('vat') }"
        :message="errors.first('vat')"
        horizontal
        :label="$translate('piva') | capitalize"
      >
        <b-input v-model="company.vat" v-validate="'required'" name="vat"></b-input>
      </b-field>
      <b-field horizontal :label="$translate('active_client') | capitalize">
        <b-switch v-model="company.isActive"></b-switch>
      </b-field>
      <b-field horizontal :label="$translate('pathologies') | capitalize">
        <b-switch v-model="company.pathologiesbool" />
      </b-field>
      <b-field horizontal :label="$translate('exportJSON') | capitalize">
        <b-switch v-model="company.exportJSON" />
      </b-field>
      <b-field horizontal :label="$translate('expectedDeliveryDate') | capitalize">
        <b-switch v-model="company.expectedDeliveryDate" />
      </b-field>
      <b-field horizontal :label="$translate('viewHistory') | capitalize">
        <b-switch v-model="company.viewHistory" />
      </b-field>
      <b-field horizontal :label="$translate('simplifiedOrder') | capitalize">
        <b-switch v-model="company.simplifiedOrder" />
      </b-field>
      <b-field horizontal :label="$translate('hideCustomOrder') | capitalize">
        <b-switch v-model="company.hideCustom" />
      </b-field>
      <b-field horizontal>
        <p class="is-size-5">{{ $translate('address') | capitalize }}</p>
      </b-field>
      <address-form :address.sync="company.address"></address-form>

      <h2 class="title">{{ $translate('orders') | capitalize }}</h2>
      <b-field horizontal :label="$translate('orderTailored') | capitalize">
        <b-switch
          v-model="company.moduleTailored"
          v-validate="{ at_least_one: [company.moduleFits, company.moduleModular, company.moduleInsole] }"
          name="moduleTailored"
        ></b-switch>
      </b-field>

      <b-field
        horizontal
        :label="$translate('orderTypetext') | capitalize"
        :type="{ 'is-danger': errors.has('orderTypeTailored') }"
        :message="errors.first('orderTypeTailored')"
      >
        <b-select
          v-model="company.bdictionary"
          v-validate="{ required: company.moduleTailored }"
          name="orderTypeTailored"
          :disabled="!company.moduleTailored"
        >
          <option disabled :value="''">{{ $translate('select_type') }}</option>
          <option v-for="option in $availableOrderType['tailored']" :key="option['key']" :value="option['key']"
            >{{ option['key'] }}
          </option>
        </b-select>
      </b-field>

      <b-field
        horizontal
        :label="$translate('deliverySelected') | capitalize"
        :type="{ 'is-danger': errors.has('deliveryTailored') }"
        :message="errors.first('deliveryTailored')"
      >
        <b-select
          v-model="company.ddictionary"
          v-validate="{ required: company.moduleTailored }"
          name="deliveryTailored"
          :disabled="!company.moduleTailored"
        >
          <option disabled :value="''">{{ $translate('select_type') }}</option>
          <option v-for="option in $availableDeliveryType['tailored']" :key="option['key']" :value="option['key']"
            >{{ option['key'] }}
          </option>
        </b-select>
      </b-field>

      <b-field horizontal :label="$translate('orderFits') | capitalize">
        <b-switch
          v-model="company.moduleFits"
          v-validate="{ at_least_one: [company.moduleTailored, company.moduleModular, company.moduleInsole] }"
          name="moduleFits"
        ></b-switch>
      </b-field>

      <b-field
        horizontal
        :label="$translate('orderTypetext') | capitalize"
        :type="{ 'is-danger': errors.has('orderTypeFits') }"
        :message="errors.first('orderTypeFits')"
      >
        <b-select
          v-model="company.bdictionary_fits"
          v-validate="{ required: company.moduleFits }"
          name="orderTypeFits"
          :disabled="!company.moduleFits"
        >
          <option disabled :value="''">{{ $translate('select_type') }}</option>
          <option v-for="option in $availableOrderType['fits']" :key="option['key']" :value="option['key']"
            >{{ option['key'] }}
          </option>
        </b-select>
      </b-field>

      <b-field
        horizontal
        :label="$translate('deliverySelected') | capitalize"
        :type="{
          'is-danger': errors.has('moduleTailored') ? errors.has('moduleTailored') : errors.has('deliveryFits'),
        }"
        :message="errors.first('deliveryFits') ? errors.first('deliveryFits') : errors.first('moduleTailored')"
      >
        <b-select
          v-model="company.ddictionary_fits"
          v-validate="{ required: company.moduleFits }"
          name="deliveryFits"
          :disabled="!company.moduleFits"
        >
          <option disabled :value="''">{{ $translate('select_type') }}</option>
          <option v-for="option in $availableDeliveryType['fits']" :key="option['key']" :value="option['key']"
            >{{ option['key'] }}
          </option>
        </b-select>
      </b-field>

      <b-field horizontal :label="$translate('orderModular') | capitalize">
        <b-switch
          v-model="company.moduleModular"
          v-validate="{ at_least_one: [company.moduleFits, company.moduleTailored, company.moduleInsole] }"
          name="moduleModular"
        ></b-switch>
      </b-field>

      <b-field
        horizontal
        :label="$translate('orderTypetext') | capitalize"
        :type="{ 'is-danger': errors.has('orderTypeModular') }"
        :message="errors.first('orderTypeModular')"
      >
        <b-select
          v-model="company.bdictionary_modular"
          v-validate="{ required: company.moduleModular }"
          name="orderTypeModular"
          :disabled="!company.moduleModular"
        >
          <option disabled :value="''">{{ $translate('select_type') }}</option>
          <option v-for="option in $availableOrderType['modular']" :key="option['key']" :value="option['key']"
            >{{ option['key'] }}
          </option>
        </b-select>
      </b-field>

      <b-field
        horizontal
        :label="$translate('deliverySelected') | capitalize"
        :type="{ 'is-danger': errors.has('deliveryModular') }"
        :message="errors.first('deliveryModular')"
      >
        <b-select
          v-model="company.ddictionary_modular"
          v-validate="{ required: company.moduleModular }"
          name="deliveryModular"
          :disabled="!company.moduleModular"
        >
          <option disabled :value="''">{{ $translate('select_type') }}</option>
          <option v-for="option in $availableDeliveryType['modular']" :key="option['key']" :value="option['key']"
            >{{ option['key'] }}
          </option>
        </b-select>
      </b-field>
      <b-field horizontal :label="$translate('orderInsole') | capitalize">
        <b-switch
          v-model="company.moduleInsole"
          v-validate="{ at_least_one: [company.moduleFits, company.moduleTailored, company.moduleInsole] }"
          name="moduleInsole"
        ></b-switch>
      </b-field>

      <b-field
        horizontal
        :label="$translate('orderTypetext') | capitalize"
        :type="{ 'is-danger': errors.has('orderTypeInsole') }"
        :message="errors.first('orderTypeInsole')"
      >
        <b-select
          v-model="company.bdictionary_insole"
          v-validate="{ required: company.moduleInsole }"
          name="orderTypeModular"
          :disabled="!company.moduleInsole"
        >
          <option disabled :value="''">{{ $translate('select_type') }}</option>
          <option v-for="option in $availableOrderType['insole']" :key="option['key']" :value="option['key']"
            >{{ option['key'] }}
          </option>
        </b-select>
      </b-field>

      <b-field
        horizontal
        :label="$translate('deliverySelected') | capitalize"
        :type="{ 'is-danger': errors.has('deliveryInsole') }"
        :message="errors.first('deliveryInsole')"
      >
        <b-select
          v-model="company.ddictionary_insole"
          v-validate="{ required: company.moduleInsole }"
          name="deliveryModular"
          :disabled="!company.moduleInsole"
        >
          <option disabled :value="''">{{ $translate('select_type') }}</option>
          <option v-for="option in $availableDeliveryType['insole']" :key="option['key']" :value="option['key']"
            >{{ option['key'] }}
          </option>
        </b-select>
      </b-field>
    </div>

    <b-modal :active.sync="isSavingModal" has-modal-card trap-focus aria-role="dialog" aria-modal :can-cancel="false">
      <div class="modal-card" style="width: auto; min-width: 200px;">
        <section class="modal-card-body">
          <b-progress type="is-success" :value="progressvalue"></b-progress>
        </section>
      </div>
    </b-modal>

    <b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
  </section>
</template>

<script>
import addressForm from '@/components/AddressForm.vue'
import keyWordGenerator from '@/helpers/mixins/keyWordGenerator.js'
import { Validator } from 'vee-validate'

Validator.extend('at_least_one', {
  params: ['target'],
  validate: (value, [target1, target2, target3]) => value || target1 || target2 || target3,
  getMessage: () => 'At least one module must be selected.',
})

export default {
  $_veeValidate: {
    validator: 'new',
  },

  name: 'companyForm',
  components: {
    'address-form': addressForm,
  },
  mixins: [keyWordGenerator],
  props: ['id'],
  data() {
    //var now = new Date();
    return {
      isLoading: false,
      isSavingModal: false,
      progressvalue: 0,
      originalCompanySnapshot: null,
      countries: [],
      modules: [
        {
          name: this.$translate('tailored'),
        },
        {
          name: this.$translate('fits'),
        },
        {
          name: this.$translate('modular'),
        },
        {
          name: this.$translate('insole'),
        },
      ],
      company: {
        name: '',
        //country: "",
        vat: '',
        email: '',
        address: {
          city: '',
          country: '',
        },
        isActive: true,
        phone: '',
        mercurio_id: '',
        bdictionary: '',
        ddictionary: '',
        bdictionary_fits: '',
        ddictionary_fits: '',
        bdictionary_modular: '',
        ddictionary_modular: '',
        bdictionary_insole: '',
        ddictionary_insole: '',
        pathologiesbool: false,
        searchArray: [],
        activeModules: [],
        moduleTailored: true,
        moduleModular: false,
        moduleFits: false,
        moduleInsole: false,
      },
    }
  },
  beforeCreate() {
    if (this.$store.getters.user.userInfo.type !== 'A') this.$router.push('/forbidden')
    return
  },
  async mounted() {
    //this.loadCountries();
    if (this.id) {
      this.isLoading = true
      await this.loadCompanyToEdit()
      this.isLoading = false
    }
  },

  methods: {
    updateModuleDetails() {
      if (!this.company.moduleTailored) {
        this.company.bdictionary = ''
        this.company.ddictionary = ''
        this.company.catalog = null
      }
      if (!this.company.moduleFits) {
        this.company.bdictionary_fits = null
        this.company.ddictionary_fits = null
        this.company.catalog_fits = null
      }
      if (!this.company.moduleModular) {
        this.company.bdictionary_modular = null
        this.company.ddictionary_modular = null
        this.company.catalog_modular = null
      }
      if (!this.company.moduleInsole) {
        this.company.bdictionary_insole = null
        this.company.ddictionary_insole = null
        this.company.catalog_insole = null
      }
    },
    deleteItem() {
      this.$buefy.dialog.confirm({
        title: this.$translate('attention'),
        message: this.$translate('delete_confirm_text'),
        cancelText: this.$translate('undo'),
        confirmText: this.$translate('delete'),
        onConfirm: () => {
          this.$db
            .collection('companies')
            .doc(this.id)
            .delete()
            .then(() => {
              this.$buefy.notification.open({
                duration: 3000,
                message: this.$translate('success_delete'),
              })
              this.$router.push({ name: 'companies' })
            })
        },
      })
    },
    send(exitbool) {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.updateModuleDetails()
          this.company.searchArray = this.generateKeyWord([
            this.company.name,
            this.company.mercurio_id,
            this.company.email,
            this.company.address.city,
          ])
          this.id === 0 || this.id == null ? this.newRequest(exitbool) : this.updateRequest(exitbool)
        } else {
          this.$buefy.notification.open({
            duration: 3000,
            message: this.$translate('failed_form'),
            type: 'is-danger',
          })
        }
      })
    },
    newRequest(exitbool) {
      this.isLoading = true
      this.company.registeredAt = new Date().getTime()
      this.$db
        .collection('companies')
        .add(this.company)
        .then(doc => {
          this.id = doc.id
          this.$buefy.notification.open({
            duration: 3000,
            message: this.$translate('success_form'),
            type: 'is-success',
          })
          this.isLoading = false

          if (exitbool) {
            this.$router.push({ name: 'companies' })
          }
        })
        .catch(() => {
          //err => {
          //console.log(err);
          this.isLoading = false

          this.$buefy.notification.open({
            duration: 3000,
            message: this.$translate('error_form_server'),
            type: 'is-danger',
          })
        })
    },
    companyOrderFieldsChanged() {
      if (!this.originalCompanySnapshot) return true
      const o = this.originalCompanySnapshot
      const c = this.company
      return (
        c.name !== o.name ||
        c.vat !== o.vat ||
        c.email !== o.email ||
        c.isActive !== o.isActive ||
        c.phone !== o.phone ||
        c.mercurio_id !== o.mercurio_id ||
        (c.address && c.address.city) !== (o.address && o.address.city) ||
        (c.address && c.address.country) !== (o.address && o.address.country)
      )
    },
    async updateRequest(exitbool) {
      if (!this.companyOrderFieldsChanged()) {
        this.isLoading = true
        await this.$db
          .collection('companies')
          .doc(this.id)
          .update(this.company)
        this.isLoading = false
        this.$buefy.notification.open({
          duration: 3000,
          message: this.$translate('success_form'),
          type: 'is-success',
        })
        if (exitbool) this.$router.push({ name: 'companies' })
        return
      }

      var batch = this.$db.batch()
      var updatecompany = this.$db.collection('companies').doc(this.id)
      let newsSearchArray = {}
      let updatedSearchArray = {}

      if (!this.company.orders || this.company.orders.length < 499) {
        //if (this.company.orders.length < -5) {
        this.isLoading = true

        let updatedCompanyOrders = []
        if (this.company.orders) {
          for (let orderId of this.company.orders) {
            let orderData = await this.$db
              .collection('orders')
              .doc(orderId)
              .get()
            let order = orderData.data()
            if (order) {
              order.id = orderId
              updatedSearchArray[orderId] = this.generateKeyWord([
                order.patient.name,
                order.patient.surname,
                order.patient.name + ' ' + order.patient.surname,
                order.primaryCode,
                order.id_mercury,
                order.tec,
                this.company.name,
              ])
              updatedCompanyOrders.push(orderId)
            }
          }
        }
        this.company.orders = updatedCompanyOrders

        //for (let orders in this.company.orders) {
        //console.log(orders)
        //await this.$db
        //.collection("orders")
        //.doc(this.company.orders[orders])
        //.get()
        //.then((doc) => {
        //console.log(doc)
        //let order = doc.data();
        //console.log(order)
        //order.id = doc.id;
        //newsSearchArray[
        //this.company.orders[orders]
        //] = this.generateKeyWord([
        //order.patient.name,
        //order.patient.surname,
        //order.patient.name + " " + order.patient.surname,
        //order.primaryCode,
        //order.id_mercury,
        //order.tec,
        //this.company.name,
        //]);
        //});
        //}
        batch.update(updatecompany, this.company)
        //TODO:500 limite
        if (this.company.orders) {
          for (let orders in this.company.orders) {
            let updateorder = this.$db.collection('orders').doc(this.company.orders[orders])
            let company = this.company
            company.id = this.id
            //console.log(company)
            batch.update(updateorder, {
              company: company,
              //searchArray: newsSearchArray[this.company.orders[orders]],
              searchArray: updatedSearchArray[this.company.orders[orders]],
            })
          }
        }

        batch
          .commit()
          .then(() => {
            this.$buefy.notification.open({
              duration: 3000,
              message: this.$translate('success_form'),
              type: 'is-success',
            })
            this.isLoading = false

            if (exitbool) {
              this.$router.push({ name: 'companies' })
            }
          })
          .catch(() => {
            //err => {
            //console.log(err);
            this.isLoading = false

            this.$buefy.notification.open({
              duration: 3000,
              message: this.$translate('error_form_server'),
              type: 'is-danger',
            })
          })
      } else {
        this.isSavingModal = true
        for (let orders in this.company.orders) {
          await this.$db
            .collection('orders')
            .doc(this.company.orders[orders])
            .get()
            .then(doc => {
              let order = doc.data()
              order.id = doc.id
              newsSearchArray[this.company.orders[orders]] = this.generateKeyWord([
                order.patient.name,
                order.patient.surname,
                order.patient.name + ' ' + order.patient.surname,
                order.primaryCode,
                order.id_mercury,
                order.tec,
                this.company.name,
              ])
            })
            .catch(() => {})
        }
        let counter = 0

        if (this.company.orders) {
          for (let orders in this.company.orders) {
            await this.$db
              .collection('orders')
              .doc(this.company.orders[orders])
              .update({
                company: this.company,
                searchArray: newsSearchArray[this.company.orders[orders]],
              })
              .then(() => {
                counter++
                this.progressvalue = (100 * counter) / this.company.orders.length - 1
              })
              .catch(() => {})
          }
        }
        await this.$db
          .collection('companies')
          .doc(this.id)
          .update(this.company)
        this.progressvalue = 100
        this.isSavingModal = false
        this.$buefy.notification.open({
          duration: 3000,
          message: this.$translate('success_form'),
          type: 'is-success',
        })
      }
    },
    /*loadCountries() {
      this.$db
        .collection("countries")
        .get()
        .then(snapshot => {
          snapshot.forEach(doc => {
            var country = doc.data();
            country.id = doc.id;
            this.countries.push(country);
          });
        });
    },*/
    async loadCompanyToEdit() {
      const companyDoc = await this.$db
        .collection('companies')
        .doc(this.id)
        .get()
      let company = companyDoc.data()
      if (!company.moduleFits && !company.moduleTailored && !company.moduleModular && !company.moduleInsole) {
        company.moduleFits = false
        company.moduleModular = false
        company.moduleTailored = true
        company.moduleInsole = false
      }
      this.company = { ...this.company, ...company }
      this.originalCompanySnapshot = {
        name: company.name,
        vat: company.vat,
        email: company.email,
        address: { city: company.address && company.address.city, country: company.address && company.address.country },
        isActive: company.isActive,
        phone: company.phone,
        mercurio_id: company.mercurio_id,
      }
    },
  },
}
</script>
